//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    if($('.u-sp').css('display') != 'none') {
      position -= 48;
    } else {
      position -= 100;
    }

    $('.wsc-h-menu a').removeClass('is-open');
    $('.wsc-h-inner').removeClass('is-open');

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  $('.wsc-h-fix').each(function(index, el) {
    var hFix = $(this);
    var about = $('.wsc-about');
    var isFix = false;
    var timer;

    run();

    $(window).on('scroll', function(event) {
      run();
    });

    function run() {
      var wT = $(window).scrollTop();
      var wC = wT;
      var aboutT = about.offset().top - 150;

      if(wC > aboutT) {

        if(!isFix) {
          isFix = true;
          hFix.addClass('is-fix');
          clearTimeout(timer);
          timer = setTimeout(function(){
            hFix.addClass('is-show');
          }, 300);
        }

      } else {
        if(isFix) {
          isFix = false;
          hFix.removeClass('is-show');
          clearTimeout(timer);
          timer = setTimeout(function() {
            hFix.removeClass('is-fix');
          }, 300)
        }
      }
    }
  });
});

$(function(){
  $('.wsc-kv-slider').each(function(index, el) {
    var slider = $(this);
    var slide = slider.find('.slide');

    setTimeout(function() {
      slide.eq(0).addClass('is-ani');
    }, 100);

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      slide.eq(nextSlide).addClass('is-ani');
      setTimeout(function() {
        slide.eq(currentSlide).removeClass('is-ani');
      }, 1000);
    });


    slider.slick({
      autoplay: true,
      autoplaySpeed: 5500,
      speed: 1500,
      fade: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: false,
      arrows: false
    });
  });
});

$(function(){
  $('.wsc-about-slider').each(function(index, el) {
    var slider = $(this);

    slider.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 2000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: true,
      dots: true,
      arrows: false
    });
  });
});

$(function(){
  $('.wsc-about-sliderSp').each(function(index, el) {
    var slider = $(this);

    slider.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      swipe: true,
      dots: true,
      arrows: false
    });
  });
});

$(function(){
  $('.wsc-pick-prodSlider').each(function(index, el) {
    var slider = $(this);

    slider.slick({
      dots: true
    });
  });
});

$(function(){
  $('.wsc-h-menu a').click(function(event) {
    $(this).toggleClass('is-open');
    $('.wsc-h-inner').toggleClass('is-open');
  });
});

$(function(){
  var link = $('.wsc-map-modalLink');

  if(link[0]) {
    var modal = $('.wsc-map-modal');
    var close = $('.wsc-map-modalClose');

    link.click(function(event) {
      runOpen($(this).attr('data-modal-target'));
    });

    close.click(function(event) {
      modal.removeClass('is-open');
    });

    function runOpen(id) {
      var tar = $('[data-modal-id="' + id + '"]');

      if(tar[0]) {
        tar.addClass('is-open');
      }
    }
  }
});

$(function(){
  var link = $('.wsc-pick-moviePlayLink');

  if(link[0]) {
    var movie = $('.wsc-pick-movie');
    var video = $('.wsc-pick-movie video');
    var videoEl = video[0];

    link.click(function(event) {
      movie.addClass('is-play');
      videoEl.play();
    });

    video.on('ended',function() {
      movie.removeClass('is-play');
    });
  }
});

//fade
$(function(){
  var fade = $('.fade');

  fade.each(function(index, el) {
    var t = $(this);

    $(window).on('load resize scroll', function(event) {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + tH * 0 / 100;
      var pointSc = winT + winH * .85;
      var pointD = 0;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    });

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

//TOPに戻るボタン
$(function(){
  var pagetop = $('#page_top');
  // ボタン非表示
  pagetop.hide();
  // 100px スクロールしたらボタン表示
  $(window).scroll(function () {
     if ($(this).scrollTop() > 100) {
          pagetop.fadeIn();
     } else {
          pagetop.fadeOut();
     }
  });
  pagetop.click(function () {
     $('body, html').animate({ scrollTop: 0 }, 500);
     return false;
  });
});
